/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TheCargo Analytics
 * Read-only analytics surface for TheCargo. Powered by an event-sourced fact store rebuilt from operational services via RabbitMQ.

## Authentication

All endpoints require a JWT Bearer token:
```
Authorization: Bearer <access_token>
```

 * OpenAPI spec version: 1.0.0
 */

export type Period = (typeof Period)[keyof typeof Period]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Period = {
  today: 'today',
  '7d': '7d',
  '30d': '30d',
  mtd: 'mtd',
  qtd: 'qtd',
  custom: 'custom',
} as const
